import { useDatabaseContent } from '@databases/database-state';
import viewAwareDatabase from '@databases/database-state/state/viewAwareDatabase';
import { defaultStoreUtils } from '@databases/redux';
import { DatabaseView } from '@databases/types/database/view';
import { isBrokenDatabase } from '@databases/utils/database/utils';
import { selectDatabaseByContentIdOptional } from '@databases/utils/redux/databases/selectors';
import { useEffect } from 'react';

const useViewAwareDatabaseLoader = ({ view }: { view: DatabaseView }) => {
  const { contentId } = useDatabaseContent();
  const state = defaultStoreUtils.useStore().getState();

  const database = defaultStoreUtils.useEqualSelector((state) => {
    const database = selectDatabaseByContentIdOptional(state, {
      contentId: contentId ?? '',
    });

    if (!database || isBrokenDatabase(database)) {
      return undefined;
    }

    return database;
  });

  useEffect(() => {
    if (contentId && view.settings) {
      viewAwareDatabase.applyDatabaseView(contentId, view.settings, state);
    }
  }, [contentId, view.settings, state]);

  useEffect(() => {
    if (database && contentId) {
      viewAwareDatabase.refreshDatabase(contentId, database, state);
    }
  }, [database, contentId, state]);
};

export default useViewAwareDatabaseLoader;
